export const PWA_PROMPT_REMINDER = 259200000;
